var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card-title",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: {
                cols: "12"
              }
            },
            [_vm._t("default")],
            2
          ),
          _vm.divider
            ? _c(
                "v-col",
                {
                  staticClass: "pa-0 gg-card-divider",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-divider", {
                    staticClass: "gg-card-divider"
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }